var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _vm.formInfo.types !== 3
        ? _c(
            "el-row",
            { staticClass: "mb10 btn-box" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleContract(3, 1)
                    },
                  },
                },
                [_vm._v(" 添加付款提醒 ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.debtData } },
        [
          _c("el-table-column", {
            attrs: { label: "付款提醒日期", "min-width": "150", prop: "time" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "业务类型", "min-width": "160", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.types == 0
                      ? _c("span", [_vm._v("合同回款")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.types == 1
                      ? _c("span", [_vm._v("合同续费")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "金额(元)", "min-width": "100", prop: "num" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", "min-width": "110", prop: "num" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.status === 1
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("已放弃"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    row.status === 2
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("已处理"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    row.status === 0
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("待处理"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "付款提醒", "min-width": "150", prop: "mark" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          content: row.mark,
                          placement: "top-start",
                          trigger: "hover",
                          width: "250",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: row.mark,
                                expression: "row.mark",
                              },
                            ],
                            staticClass: "over-text hand",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [_vm._v(" " + _vm._s(row.mark) + " ")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("hr.founder"),
              "min-width": "100",
              prop: "card.name",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("public.operation"),
              fixed: "right",
              "min-width": "180",
              prop: "address",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.types === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: scope.row.status !== 0,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleBuild(
                                  scope.row,
                                  _vm.buildData.contract_refund_switch,
                                  "contract_refund_switch"
                                )
                              },
                            },
                          },
                          [_vm._v("添加回款")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.types === 1
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: scope.row.status !== 0,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleBuild(
                                  scope.row,
                                  _vm.buildData.contract_renew_switch,
                                  "contract_renew_switch"
                                )
                              },
                            },
                          },
                          [_vm._v("添加续费")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: scope.row.status !== 0,
                          type: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleContract(3, 2, scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.edit")))]
                    ),
                    _vm._v(" "),
                    scope.row.bill_id > 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: scope.row.status !== 0,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.giveUpFn(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          放弃")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.bill_id <= 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.delete")))]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.debtData.length > 0
        ? _c(
            "div",
            { staticClass: "block mt10 text-right" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.debtPage,
                  "page-size": _vm.where.limit,
                  total: _vm.debtTotal,
                  layout: "total, prev, pager, next, jumper",
                },
                on: { "current-change": _vm.debtChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { ids: _vm.formInfo.data.id, parameterData: _vm.parameterData },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("contract-dialog", {
        ref: "contractDialog",
        attrs: { config: _vm.configContract },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("mark-dialog", {
        ref: "markDialog",
        attrs: { config: _vm.configMark },
        on: { isMark: _vm.isOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }